import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './CatalogManagement.css';
import CategoriesTab from './CategoriesTab';
import CatalogViewTab from './CatalogViewTab';
import FeaturedTab from './FeaturedTab';
import useCatalogManagementStore from '@/stores/AdminStore/CatalogManagementStore';

const CatalogManagement: React.FC = () => {
  const location = useLocation();
  const initialTab = (location.state as any)?.activeTab || 'categories';
  const [activeTab, setActiveTab] = useState<'categories' | 'catalog' | 'featured'>(initialTab);

  const {
    categories,
    catalogCourses,
    featuredCourses,
    recommendationRules,
    fetchCategories,
    fetchCatalogCourses,
    fetchFeaturedCourses,
    fetchRecommendationRules,
  } = useCatalogManagementStore();

  // Lazy load data based on active tab
  useEffect(() => {
    if (activeTab === 'categories' && !categories) {
      fetchCategories();
    }
  }, [activeTab, categories, fetchCategories]);

  useEffect(() => {
    if (activeTab === 'catalog' && !catalogCourses) {
      fetchCatalogCourses();
    }
  }, [activeTab, catalogCourses, fetchCatalogCourses]);

  useEffect(() => {
    if (activeTab === 'featured' && !featuredCourses) {
      fetchFeaturedCourses();
    }
    if (activeTab === 'featured' && !recommendationRules) {
      fetchRecommendationRules();
    }
  }, [activeTab, featuredCourses, recommendationRules, fetchFeaturedCourses, fetchRecommendationRules]);

  return (
    <div className="admin-catalog-management">
      <div className="admin-catalog-breadcrumb">
        <span className="admin-catalog-breadcrumb-item">Content Management</span>
        <span className="admin-catalog-breadcrumb-separator">›</span>
        <span className="admin-catalog-breadcrumb-item admin-catalog-current">Catalog / Category</span>
      </div>

      <header className="admin-catalog-page-header">
        <div className="admin-catalog-header-content">
          <h1 className="admin-catalog-page-title">Catalog / Category Management</h1>
          <p className="admin-catalog-page-subtitle">Manage learning taxonomy and course discoverability</p>
        </div>
      </header>

      <nav className="admin-catalog-tabs">
        <button
          className={`admin-catalog-tab ${activeTab === 'categories' ? 'admin-catalog-active' : ''}`}
          onClick={() => setActiveTab('categories')}
        >
          Categories
        </button>
        <button
          className={`admin-catalog-tab ${activeTab === 'catalog' ? 'admin-catalog-active' : ''}`}
          onClick={() => setActiveTab('catalog')}
        >
          Catalog View
        </button>
        <button
          className={`admin-catalog-tab ${activeTab === 'featured' ? 'admin-catalog-active' : ''}`}
          onClick={() => setActiveTab('featured')}
        >
          Featured & Recommended
        </button>
      </nav>

      <div className="admin-catalog-content-section">
        {activeTab === 'categories' && <CategoriesTab />}
        {activeTab === 'catalog' && <CatalogViewTab />}
        {activeTab === 'featured' && <FeaturedTab />}
      </div>
    </div>
  );
};

export default CatalogManagement;
